// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1A030","image":"Header_image__3j1Yw","name":"Header_name__YLPcY","info":"Header_info__3fVIT","infoRow":"Header_infoRow__3dQ71"};